// Ancient Japan Trainers Data - Group Five (Final Characters 25-30)

// Kendo Master's workout programs
const kendoMasterPrograms = [
    {
        id: 'way-of-the-sword-training',
        name: 'Way of the Sword Training',
        description: 'Modern evolution of ancient samurai swordsmanship with bamboo precision',
        pattern: '^*&h)(',
        reps: 1,
        sets: 20,
        focus: 'Sword Precision'
    },
    {
        id: 'bamboo-spirit-conditioning',
        name: 'Bamboo Spirit Conditioning',
        description: 'Flexible strength training inspired by the resilient bamboo sword',
        pattern: '*^h&)(',
        reps: 8,
        sets: 9,
        focus: 'Bamboo Resilience'
    },
    {
        id: 'dojo-discipline-workout',
        name: 'Dojo Discipline Workout',
        description: 'Traditional training hall conditioning with modern safety principles',
        pattern: 'h)(*^&',
        reps: 16,
        sets: 5,
        focus: 'Dojo Excellence'
    },
    {
        id: 'kata-perfection-protocol',
        name: 'Kata Perfection Protocol',
        description: 'Form-based training that builds muscle memory and spiritual focus',
        pattern: ')(*&^h',
        reps: 12,
        sets: 7,
        focus: 'Form Perfection'
    },
    {
        id: 'tournament-champion-training',
        name: 'Tournament Champion Training',
        description: 'Competitive conditioning for modern kendo championship glory',
        pattern: '(*&h^)',
        reps: 24,
        sets: 3,
        focus: 'Championship Glory'
    },
    {
        id: 'modern-samurai-mastery',
        name: 'Modern Samurai Mastery',
        description: 'Complete evolution of bushido spirit into contemporary excellence',
        pattern: '^*&h)(!',
        reps: 18,
        sets: 4,
        focus: 'Modern Bushido'
    }
];

// Kyudo Archer's workout programs
const kyudoArcherPrograms = [
    {
        id: 'zen-archery-training',
        name: 'Zen Archery Training',
        description: 'Meditative bow training that unifies mind, body, and spirit',
        pattern: '_^@fwd',
        reps: 4,
        sets: 16,
        focus: 'Zen Precision'
    },
    {
        id: 'breathing-bow-conditioning',
        name: 'Breathing Bow Conditioning',
        description: 'Respiratory control training for perfect shot timing and focus',
        pattern: '^_@dfw',
        reps: 7,
        sets: 11,
        focus: 'Breath Control'
    },
    {
        id: 'spiritual-accuracy-workout',
        name: 'Spiritual Accuracy Workout',
        description: 'Target practice that shoots at internal obstacles and limitations',
        pattern: '@dfw_^',
        reps: 21,
        sets: 4,
        focus: 'Spiritual Accuracy'
    },
    {
        id: 'ceremonial-form-protocol',
        name: 'Ceremonial Form Protocol',
        description: 'Ritual movement training that honors the sacred nature of archery',
        pattern: 'dfw^_@',
        reps: 5,
        sets: 13,
        focus: 'Sacred Ceremony'
    },
    {
        id: 'yumi-master-training',
        name: 'Yumi Master Training',
        description: 'Advanced longbow conditioning for drawing the powerful Japanese bow',
        pattern: 'fw^@d_',
        reps: 28,
        sets: 3,
        focus: 'Longbow Mastery'
    },
    {
        id: 'way-of-bow-mastery',
        name: 'Way of Bow Mastery',
        description: 'Complete path of kyudo that achieves perfect unity through archery',
        pattern: '_^@fwd!',
        reps: 49,
        sets: 2,
        focus: 'Archery Unity'
    }
];

// Miyamoto Musashi's workout programs
const miyamotoMusashiPrograms = [
    {
        id: 'two-sword-technique-training',
        name: 'Two Sword Technique Training',
        description: 'Dual-wielding conditioning for simultaneous offense and defense',
        pattern: 'emk*)(h',
        reps: 2,
        sets: 21,
        focus: 'Dual Mastery'
    },
    {
        id: 'book-of-five-rings-conditioning',
        name: 'Book of Five Rings Conditioning',
        description: 'Training based on the five elements of strategic combat mastery',
        pattern: 'mk*)he',
        reps: 5,
        sets: 17,
        focus: 'Five Elements'
    },
    {
        id: 'undefeated-duelist-workout',
        name: 'Undefeated Duelist Workout',
        description: 'Solo combat training that builds invincible one-on-one supremacy',
        pattern: 'k*)hem',
        reps: 60,
        sets: 1,
        focus: 'Dueling Supremacy'
    },
    {
        id: 'ronin-independence-protocol',
        name: 'Ronin Independence Protocol',
        description: 'Self-reliant training for warriors who walk their own path',
        pattern: '*)hemk',
        reps: 13,
        sets: 8,
        focus: 'Independent Warrior'
    },
    {
        id: 'void-strategy-training',
        name: 'Void Strategy Training',
        description: 'Training in the fifth ring - the formless strategy beyond technique',
        pattern: ')hemk*',
        reps: 35,
        sets: 3,
        focus: 'Formless Strategy'
    },
    {
        id: 'sword-saint-mastery',
        name: 'Sword Saint Mastery',
        description: 'Ultimate training of Japan\'s greatest swordsman and strategist',
        pattern: 'emk*)(h!',
        reps: 21,
        sets: 5,
        focus: 'Sword Sainthood'
    }
];

// Minamoto no Yoshitsune's workout programs
const minamotoYoshitsunePrograms = [
    {
        id: 'tragic-hero-training',
        name: 'Tragic Hero Training',
        description: 'Brilliant combat training shadowed by inevitable tragic destiny',
        pattern: 'gavy~q',
        reps: 9,
        sets: 12,
        focus: 'Tragic Brilliance'
    },
    {
        id: 'lightning-tactics-conditioning',
        name: 'Lightning Tactics Conditioning',
        description: 'Revolutionary speed-based warfare that changed Japanese combat',
        pattern: 'avy~qg',
        reps: 31,
        sets: 3,
        focus: 'Lightning War'
    },
    {
        id: 'dan-no-ura-victory-workout',
        name: 'Dan-no-Ura Victory Workout',
        description: 'Naval combat training from the decisive sea battle victory',
        pattern: 'vy~qga',
        reps: 17,
        sets: 6,
        focus: 'Naval Supremacy'
    },
    {
        id: 'brother-loyalty-protocol',
        name: 'Brother Loyalty Protocol',
        description: 'Training focused on family bonds and ultimate sacrifice for duty',
        pattern: 'y~qgav',
        reps: 22,
        sets: 4,
        focus: 'Loyal Sacrifice'
    },
    {
        id: 'elegant-warrior-training',
        name: 'Elegant Warrior Training',
        description: 'Graceful combat style that combines beauty with devastating effectiveness',
        pattern: '~qgavy',
        reps: 14,
        sets: 7,
        focus: 'Elegant Lethality'
    },
    {
        id: 'legendary-yoshitsune-mastery',
        name: 'Legendary Yoshitsune Mastery',
        description: 'Complete training of the most beloved tragic hero in Japanese history',
        pattern: 'gavy~q!',
        reps: 26,
        sets: 4,
        focus: 'Heroic Legend'
    }
];

// Geisha Master's workout programs
const geishaMasterPrograms = [
    {
        id: 'graceful-artistry-training',
        name: 'Graceful Artistry Training',
        description: 'Elegant movement training that transforms every gesture into art',
        pattern: 'wad_^z',
        reps: 3,
        sets: 18,
        focus: 'Graceful Artistry'
    },
    {
        id: 'cultural-refinement-conditioning',
        name: 'Cultural Refinement Conditioning',
        description: 'Sophisticated training in music, dance, and conversational arts',
        pattern: 'ad_^zw',
        reps: 6,
        sets: 11,
        focus: 'Cultural Sophistication'
    },
    {
        id: 'tea-house-endurance-workout',
        name: 'Tea House Endurance Workout',
        description: 'Stamina training for long evenings of entertainment and hospitality',
        pattern: 'd_^zwa',
        reps: 12,
        sets: 8,
        focus: 'Entertainment Endurance'
    },
    {
        id: 'kimono-elegance-protocol',
        name: 'Kimono Elegance Protocol',
        description: 'Movement training while wearing traditional formal garments',
        pattern: '_^zwad',
        reps: 15,
        sets: 5,
        focus: 'Formal Elegance'
    },
    {
        id: 'artistic-perfection-training',
        name: 'Artistic Perfection Training',
        description: 'Discipline training for achieving mastery in traditional Japanese arts',
        pattern: '^zwad_',
        reps: 9,
        sets: 9,
        focus: 'Artistic Mastery'
    },
    {
        id: 'ultimate-geisha-excellence',
        name: 'Ultimate Geisha Excellence',
        description: 'Complete training in the refined cultural arts of traditional Japan',
        pattern: 'wad_^z!',
        reps: 27,
        sets: 3,
        focus: 'Cultural Excellence'
    }
];

// Saito Hajime's workout programs (THE MISSING 6TH TRAINER!)
const saitoHajimePrograms = [
    {
        id: 'left-handed-sword-training',
        name: 'Left-Handed Sword Training',
        description: 'Unique southpaw technique that confuses and devastates opponents',
        pattern: 'qw&*^z',
        reps: 11,
        sets: 9,
        focus: 'Southpaw Mastery'
    },
    {
        id: 'shinsengumi-discipline-conditioning',
        name: 'Shinsengumi Discipline Conditioning',
        description: 'Elite police unit training with unwavering loyalty and precision',
        pattern: 'w&*^zq',
        reps: 19,
        sets: 5,
        focus: 'Elite Discipline'
    },
    {
        id: 'gatotsu-thrust-workout',
        name: 'Gatotsu Thrust Workout',
        description: 'Devastating one-thrust technique that ends fights instantly',
        pattern: '&*^zqw',
        reps: 1,
        sets: 30,
        focus: 'One-Thrust Kill'
    },
    {
        id: 'wolf-of-mibu-protocol',
        name: 'Wolf of Mibu Protocol',
        description: 'Ferocious training that channels the predatory instincts of a wolf',
        pattern: '*^zqw&',
        reps: 7,
        sets: 12,
        focus: 'Predatory Instinct'
    },
    {
        id: 'police-captain-training',
        name: 'Police Captain Training',
        description: 'Leadership conditioning for maintaining order in chaotic times',
        pattern: '^zqw&*',
        reps: 25,
        sets: 4,
        focus: 'Order & Authority'
    },
    {
        id: 'lone-wolf-mastery',
        name: 'Lone Wolf Mastery',
        description: 'Complete training of the silent, deadly captain of the Shinsengumi',
        pattern: 'qw&*^z!',
        reps: 33,
        sets: 3,
        focus: 'Silent Lethality'
    }
];

// Main Ancient Japan trainers data object - Group Five (Complete with 6 trainers)
const japanFiveTrainersData = {
    'kendo-master': {
        id: 'kendo-master',
        name: 'Kendo Master',
        specialization: 'Modern Swordsmanship & Bamboo Spirit',
        image: '/assets/images/kendo-master.jpg',
        experience: '40+ years',
        category: 'ancient-japan',
        color: '#000080',
        secondaryColor: '#FFFFFF',
        intro: `Master of the modern evolution of samurai swordsmanship, the Kendo Master preserves ancient bushido spirit through contemporary training methods. His bamboo sword discipline teaches that true strength comes from flexibility, precision, and respect for opponents. Every strike carries the weight of centuries of warrior tradition.`,
        programs: kendoMasterPrograms
    },
    'kyudo-archer': {
        id: 'kyudo-archer',
        name: 'Kyudo Master',
        specialization: 'Zen Archery & Spiritual Precision',
        image: '/assets/images/kyudo-archer.jpg',
        experience: '35+ years',
        category: 'ancient-japan',
        color: '#8B4513',
        secondaryColor: '#F5DEB3',
        intro: `Master of the Way of the Bow, achieving perfect unity of mind, body, and spirit through meditative archery. Her training teaches that the true target is not the mark on the wall, but the obstacles within oneself. Every arrow released carries the archer's entire being toward enlightenment.`,
        programs: kyudoArcherPrograms
    },
    'miyamoto-musashi': {
        id: 'miyamoto-musashi',
        name: 'Miyamoto Musashi',
        specialization: 'Two-Sword Style & Strategic Mastery',
        image: '/assets/images/miyamoto-musashi.jpg',
        experience: '60+ years',
        category: 'ancient-japan',
        color: '#2F4F4F',
        secondaryColor: '#C0C0C0',
        intro: `The legendary Sword Saint who never lost a duel and wrote the definitive strategy guide "The Book of Five Rings." His two-sword technique and philosophical approach to combat revolutionized martial arts. Students learn that true victory comes not from strength alone, but from understanding the rhythm of conflict itself.`,
        programs: miyamotoMusashiPrograms
    },
    'minamoto-no-yoshitsune': {
        id: 'minamoto-no-yoshitsune',
        name: 'Minamoto no Yoshitsune',
        specialization: 'Lightning Tactics & Tragic Heroism',
        image: '/assets/images/minamoto-yoshitsune.jpg',
        experience: '30+ years',
        category: 'ancient-japan',
        color: '#DC143C',
        secondaryColor: '#FFB6C1',
        intro: `The most beloved tragic hero in Japanese history, whose brilliant military innovations changed warfare forever. His lightning-fast tactics and elegant combat style made him legendary, though political tragedy cut his life short. Students learn that true greatness sometimes requires sacrificing everything for honor and family loyalty.`,
        programs: minamotoYoshitsunePrograms
    },
    'geisha-master': {
        id: 'geisha-master',
        name: 'Geisha Master',
        specialization: 'Cultural Arts & Refined Movement',
        image: '/assets/images/geisha-master.jpg',
        experience: '25+ years',
        category: 'ancient-japan',
        color: '#FF1493',
        secondaryColor: '#FFE4E1',
        intro: `Master of traditional Japanese cultural arts, combining music, dance, conversation, and hospitality into perfect aesthetic expression. Her training develops grace under pressure and the ability to transform any social situation into harmonious beauty. True strength sometimes appears as gentleness, and true power as refined elegance.`,
        programs: geishaMasterPrograms
    },
    'saito-hajime': {
        id: 'saito-hajime',
        name: 'Saito Hajime',
        specialization: 'Left-Handed Swordsmanship & Shinsengumi Discipline',
        image: '/assets/images/saito-hajime.jpg',
        experience: '45+ years',
        category: 'ancient-japan',
        color: '#483D8B',
        secondaryColor: '#E6E6FA',
        intro: `The legendary captain of the Shinsengumi's 3rd unit, known as the "Wolf of Mibu" for his silent, deadly efficiency. His unique left-handed sword technique and devastating Gatotsu thrust made him one of the most feared swordsmen of the Bakumatsu period. Students learn that true strength often comes from unconventional approaches and unwavering discipline.`,
        programs: saitoHajimePrograms
    }
};

// Export the data
export default japanFiveTrainersData;